export default __webpack_public_path__ + "static/media/nour-seen-logo.35f66063.png";